'use strict';

var $ = require('jquery'),
  Backbone = require('backbone');
Backbone.$ = $;

var SearchDoublePlaceholderView = Backbone.View.extend({
  events: {
    keyup: 'showHide'
  },
  initialize: function() {
    this.$input = this.$el.find('input');
    this.$el.addClass('SearchDoublePlaceholder-loaded');
    this.desiredClass = 'SearchDoublePlaceholder-hidetext';
    this.showHide();
  },
  showHide: function() {
    if (this.$input.val().length > 0) {
      this.$el.addClass(this.desiredClass);
    } else {
      this.$el.removeClass(this.desiredClass);
    }
  }
}, {
  create: function($parent) {
    $parent.find('.SearchDoublePlaceholder').each(function(n, el) {
      new SearchDoublePlaceholderView({
        el: el
      });
    });
  }
});

module.exports = SearchDoublePlaceholderView;



// WEBPACK FOOTER //
// ./assets/js/components/SearchDoublePlaceholder.js